import { ChangeDetectionStrategy, Component, input, linkedSignal, output } from '@angular/core';
import { LocalizedByteFormatPipe } from '@myarvato/shared/localized-byte-format-pipe';
import { Button } from 'primeng/button';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'transport-select-file',
  imports: [LocalizedByteFormatPipe, Button, TranslatePipe],
  templateUrl: './select-file.component.html',
  styleUrl: './select-file.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SelectFileComponent {
  // input
  public readonly selectedFile = input<File | undefined>(undefined);

  protected currentlySelectedFile = linkedSignal<File | undefined>(() => this.selectedFile());

  // output
  public readonly fileSelected = output<File | undefined>();

  protected onFileSelected(event: Event): void {
    const inputElement = event.target as HTMLInputElement;
    if (!inputElement.files?.length) {
      return;
    }

    this.currentlySelectedFile.set(inputElement.files[0]);
    this.fileSelected.emit(inputElement.files[0]);
  }

  protected removeFile(): void {
    this.currentlySelectedFile.set(undefined);
    this.fileSelected.emit(undefined);
  }
}
